import { Injectable } from '@angular/core';
import { HttpService, MessageService } from 'brainloper-ui';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
// import { registerPlugin } from '@capacitor/core';
// import { CurrentLocationActiveRoute } from 'app/models2/localization/current-location-active-route';
// import { BackgroundTask } from '@capawesome/capacitor-background-task';

// const BackgroundGeolocation = registerPlugin<BackgroundGeolocationPlugin>('BackgroundGeolocation');



@Injectable({
  providedIn: 'root'
})
export class GeolocationService {

  private urlCurrentLocalization: string = `${EndpointDictionary.Travelhistory.CURRENT_LOCALIZATION}`
  private currentPosition: { latitude: number, longitude: number } | null = null;

  constructor(
    private message: MessageService,
    private http: HttpService,
  ) {

  }

  getPosition(): Promise<GeolocationPosition> {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        resp => {
          resolve(resp);
        },
        err => {
          reject(err);
        }
      );
    });
  }

  getPositionResult(callback: (pos: GeolocationPosition) => void): void {
    this.message.openLoading('Cargando', 'Obteniendo permisos de ubicación');
    this.getPosition().then(res => {
      callback(res);
    }).catch(err => {
      if (err.code === 1) {
        this.message.Error('Error', 'Debe permitir compartir su ubicación')
      }
      console.error("Erro getPosition", err);
    });
    this.message.closeLoading();
  }
;
  // getPositionResultWithCapacitor(callback: (pos: { latitude: number, longitude: number }) => void): void {
  //   this.guessLocation((location) => {
  //     if (location) {
  //       callback({ latitude: location.latitude, longitude: location.longitude });
  //     } else {
  //       this.message.Error('Error', 'No se pudo obtener la ubicación actual.');
  //     }
  //   }); 
  // }


  // Activa la geolocalización en segundo plano
  // activeBackgroundGeolocation(historicalTravelId: number, routerId: number) {

  //   let lastSentTime = 0;

  //   const startBackgroundTask = () => {
  //     BackgroundTask.beforeExit(async () => {
  //         const currentTime = Date.now();
  //         if (currentTime - lastSentTime >= 300000) { // 300000 ms = 5 minutos
  //             lastSentTime = currentTime;

  //             console.log('Enviando datos de ubicación al backend.');

  //             let body: CurrentLocationActiveRoute = {
  //               latitude: this.currentPosition.latitude, 
  //               longitude: this.currentPosition.longitude, 
  //               historicalTravelId, 
  //               routerId}
              
  //               let res = await this.http.postDataBody(
  //                 this.urlCurrentLocalization, 
  //                 body

  //               );
  //               console.log('Ubicación enviada desde geolocalizacion al backend:', res)
  //         }

  //         // Reactivar la tarea en segundo plano
  //         startBackgroundTask();
  //         console.log('Tarea en segundo plano completada.');
  //     });
  // };

  //   BackgroundGeolocation.addWatcher({
  //     requestPermissions: true,
  //     stale: false, //false para obtener la ubicacion actual
  //     backgroundMessage: 'La aplicación está rastreando tu ubicación en segundo plano.',
  //     backgroundTitle: 'Rastreo en segundo plano activo',
  //   //  distanceFilter: 0,  //distacia minima en metros para que se actualice la ubicacion

  //   }, async (position, error) => {
  //     if (error) {
  //       console.error('Error obteniendo ubicación:', error);
  //       return;
  //     }
  //     this.currentPosition = position;
      
  //     // Iniciar la tarea en segundo plano
  //       startBackgroundTask();
        

  //   }
  //   ).catch(err => {
  //     this.message.Error('Error en activeBackgroundGeolocation', err);
  //     if (err.code === 1) {
  //       this.message.Error('Error', 'Debe permitir compartir su ubicación');
  //     }
  //   });;
  // }

 
  // guessLocation(callback, timeout = 10000) {
  //   let lastLocation;
  //   BackgroundGeolocation.addWatcher(
  //     {
  //       requestPermissions: true, // Solicita permisos si no están otorgados
  //       stale: true
  //     },
  //     (location) => {
  //       lastLocation = location || undefined;
  //     }
  //   ).then(id => {
  //     setTimeout(() => {
  //       callback(lastLocation);
  //       BackgroundGeolocation.removeWatcher({ id });
  //     }, timeout);
  //   }).catch(err => {
  //     this.message.Error('Error en guessLocation', err);
  //     if (err.code === 1) {
  //       this.message.Error('Error', 'Debe permitir compartir su ubicación');
  //     }
  //   });
  // }
}